import {CrewSample} from './crew';
import {CompetitorSimple} from './competitor';

export class CompetitionRegistration {
  id: number;
  noteCompetitor: string;
  noteAuthor: string;
  accommodationFrom: Date;
  accommodationTo: Date;
  registrationTime: Date;
  competitionId: number;
  crewId: number;
  driverId: number;
  navigatorId: number;
  additionalCompetitors: string;

  constructor(
    id = null,
    competitionId = null,
    crewId = null,
    accommodationFrom = new Date(),
    accommodationTo = new Date(),
    registrationTime = new Date(),
    noteCompetitor = '',
    noteAuthor = '',
    driverId = null,
    navigatorId = null,
    additionalCompetitors = null
  ) {
    this.id = id;
    this.noteCompetitor = noteCompetitor;
    this.noteAuthor = noteAuthor;
    this.accommodationFrom = accommodationFrom;
    this.accommodationTo = accommodationTo;
    this.registrationTime = registrationTime;
    this.competitionId = competitionId;
    this.crewId = crewId;
    this.driverId = driverId;
    this.navigatorId = navigatorId;
    this.additionalCompetitors = additionalCompetitors;
  }
}

export class CompetitionRegistrationFull {
  id: number;
  noteCompetitor: string;
  noteAuthor: string;
  accommodationFrom: Date;
  accommodationTo: Date;
  competitionId: number;
  crew: CrewSample;
  driver: CompetitorSimple;
  navigator: CompetitorSimple;
  additionalCompetitors: CompetitorSimple[];

  constructor(
    id = null,
    competitionId = null,
    crew = null,
    accommodationFrom = new Date(),
    accommodationTo = new Date(),
    noteCompetitor = '',
    noteAuthor = '',
    driver = null,
    navigator = null,
    additionalCompetitors = []
  ) {
    this.id = id;
    this.noteCompetitor = noteCompetitor;
    this.noteAuthor = noteAuthor;
    this.accommodationFrom = accommodationFrom;
    this.accommodationTo = accommodationTo;
    this.competitionId = competitionId;
    this.crew = crew;
    this.driver = driver;
    this.navigator = navigator;
    this.additionalCompetitors = additionalCompetitors;
  }
}

export class CompetitionRegistrationSimple {
  id: number;
  noteCompetitor: string;
  registrationTime: Date;
  competitionId: number;
  crew: CrewSample;
  driver: CompetitorSimple;
  navigator: CompetitorSimple;

  constructor(
    id = null,
    competitionId = null,
    crew = null,
    noteCompetitor = '',
    registrationTime = new Date(),
    driver = null,
    navigator = null
  ) {
    this.id = id;
    this.noteCompetitor = noteCompetitor;
    this.registrationTime = registrationTime;
    this.competitionId = competitionId;
    this.crew = crew;
    this.driver = driver;
    this.navigator = navigator;
  }
}

export class CompetitionRegistrationEdit {
  id: number;
  noteCompetitor: string;
  accommodationFrom: Date;
  accommodationTo: Date;
  competitionId: number;
  crew: CrewSample;
  driver: CompetitorSimple;
  navigator: CompetitorSimple;
  additionalCompetitors: CompetitorSimple[];

  constructor(
    id = null,
    competitionId = null,
    crew = null,
    accommodationFrom = new Date(),
    accommodationTo = new Date(),
    noteCompetitor = '',
    driver = null,
    navigator = null,
    additionalCompetitors = []
  ) {
    this.id = id;
    this.noteCompetitor = noteCompetitor;
    this.accommodationFrom = accommodationFrom;
    this.accommodationTo = accommodationTo;
    this.competitionId = competitionId;
    this.crew = crew;
    this.driver = driver;
    this.navigator = navigator;
    this.additionalCompetitors = additionalCompetitors;
  }
}

export class CompetitionRegistrationEditRequest {
  id: number;
  noteCompetitor: string;
  registrationTime: Date;
  accommodationFrom: Date;
  accommodationTo: Date;
  competitionId: number;
  crewId: number;
  driverId: number;
  navigatorId: number;
  additionalCompetitors: string;

  constructor(
    id = null,
    competitionId = null,
    crewId = null,
    registrationTime = new Date(),
    accommodationFrom = new Date(),
    accommodationTo = new Date(),
    noteCompetitor = '',
    driverId = null,
    navigatorId = null,
    additionalCompetitors = null
  ) {
    this.id = id;
    this.noteCompetitor = noteCompetitor;
    this.registrationTime = registrationTime;
    this.accommodationFrom = accommodationFrom;
    this.accommodationTo = accommodationTo;
    this.competitionId = competitionId;
    this.crewId = crewId;
    this.driverId = driverId;
    this.navigatorId = navigatorId;
    this.additionalCompetitors = additionalCompetitors;
  }
}
